import { createIllustration, type SVGViewBox } from '@atlassian/jira-illustration';
import src from '../../assets/map-planning.svg'; // eslint-disable-line jira/import/no-parent-imports

const Illustration = createIllustration({
	srcLight: src,
	srcDark: src,
	autoDark: false,
});

export default Illustration;

// for advanced use only
const viewBox: SVGViewBox = [0, 0, 587, 593];
export { src as srcLight, src as srcDark, viewBox };
